/*
 * Size dropdown on the Estee product cards (snippets/card-product-estee.liquid).
 * Switching size updates the price, the add-to-cart variant and the sold-out state,
 * then re-checks automatic discounts for the new size via estee-discount-prices.js.
 */
(function () {
  if (window.esteeProductCardInit) return;
  window.esteeProductCardInit = true;

  function formatMoney(cents) {
    if (window.esteeDiscountPrices && window.esteeDiscountPrices.formatMoney) {
      return window.esteeDiscountPrices.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Regular (non-discounted) price for the selected size
  function renderPrice(card, price, compare) {
    var wrap = card.querySelector('.estee-price-wrap');
    var current = wrap.querySelector('.estee-price-current');
    var compareEl = wrap.querySelector('.estee-price-compare');
    var percent = compare > price ? Math.round(((compare - price) * 100) / compare) : 0;

    current.textContent = formatMoney(price);

    if (percent > 0) {
      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'estee-price-compare';
        wrap.appendChild(compareEl);
      }
      compareEl.textContent = formatMoney(compare);
    } else if (compareEl) {
      compareEl.remove();
    }

    if (window.esteeDiscountPrices) window.esteeDiscountPrices.setBadge(card, percent);
  }

  function onVariantChange(select) {
    var card = select.closest('.estee-product-card');
    var option = select.options[select.selectedIndex];
    if (!card || !option) return;

    var price = parseInt(option.dataset.price, 10);
    var compare = parseInt(option.dataset.comparePrice, 10) || 0;
    var available = option.dataset.available === 'true';

    var idInput = card.querySelector('.estee-card-form [name="id"]');
    if (idInput) idInput.value = option.value;

    var button = card.querySelector('.estee-card-atc');
    if (button) {
      button.disabled = !available;
      var label = button.querySelector('.btn__text');
      if (label) label.textContent = available ? label.dataset.addText : label.dataset.soldOutText;
    }

    var wrap = card.querySelector('.estee-price-wrap');
    wrap.dataset.variantId = option.value;
    wrap.dataset.price = price;
    wrap.dataset.comparePrice = compare;
    renderPrice(card, price, compare);

    // Let the discount script price the new size
    wrap.removeAttribute('data-discount-checked');
    if (window.esteeDiscountPrices) window.esteeDiscountPrices.update(card);
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('.estee-variant-select')) {
      onVariantChange(event.target);
    }
  });
})();
